<template>
  <div>
    <div class="card">
      <dl>
        <dt>Rolle</dt>
        <dd>{{bruker.rolle ? bruker.rolle.name : '-'}}</dd>

        <dt>Avdeling</dt>
        <dd>{{bruker.avdeling ? bruker.avdeling.Beskrivelse : '-'}}</dd>

        <dt>Aktiv</dt>
        <dd>{{bruker.Inaktiv === 'F' ? 'Ja' : 'Nei'}}</dd>

        <dt>E-post</dt>
        <dd v-if="bruker.Email">
          <a :href="'mailto:' + bruker.Email">{{bruker.Email}}</a>
        </dd>
        <dd v-else>-</dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KundeCardSidebarTabProfile',
  props: {
    bruker: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/BrukerCardSidebarTabProfile.vue